import React from "react";
import PropTypes from "prop-types";
import { Box } from "@material-ui/core";
import { ErrorOutlineOutlined } from "@material-ui/icons";
import { makeStyles } from "@material-ui/core/styles";
import { Typography } from "components/common";
import SrCurrency from "components/common/SrCurrency";

const useStyles = makeStyles((theme) => ({
  infoItem: {
    textDecoration: "none",
    whiteSpace: "nowrap",
  },
  helpIcon: {
    marginLeft: theme.spacing(1),
    fontSize: theme.typography.h5.fontSize,
    lineHeight: theme.typography.h5.lineHeight,
    cursor: "pointer",
    verticalAlign: "middle",
    marginBottom: theme.spacing(0.5),
  },
}));

const Info = ({ infoName, infoValue, textDirection, onIconClick, size }) => {
  const classes = useStyles();
  return (
    <Box
      display="flex"
      flexDirection={textDirection}
      gridGap={textDirection === "row" ? 8 : 0}
    >
      <Typography
        variant={size === "normal" ? "h4Regular" : "body1WhiteColor"}
        className={classes.infoItem}
      >
        {infoName}
      </Typography>
      <Box display="flex">
        <Typography
          variant={size === "normal" ? "h4Semibold" : "h5SmallerWhite"}
          className={classes.infoItem}
          color={infoValue >= 0 ? "initial" : "error"}
        >
          <SrCurrency value={infoValue} />
        </Typography>
        <Typography
          variant={size === "normal" ? "h4Semibold" : "h5SmallerWhite"}
          className={classes.infoItem}
        >
          <ErrorOutlineOutlined
            className={classes.helpIcon}
            onClick={onIconClick}
          />
        </Typography>
      </Box>
    </Box>
  );
};

Info.propTypes = {
  infoName: PropTypes.shape({}).isRequired,
  infoValue: PropTypes.number.isRequired,
  textDirection: PropTypes.string.isRequired,
  color: PropTypes.string,
  onIconClick: PropTypes.func.isRequired,
};

Info.defaultProps = {
  color: undefined,
};

export default Info;
